<template>
  <div>
    <my-table :title="title"
              :isAdd="isAdd"
              :isSearch="isSearch"
              :search-params="searchParams"
              :tableData="tableData"
              @search="search"
              @keyup.enter.native="keyup()"
              @pageNumChange="pageNumChange"
              @add="addMerchants">
      <div slot="table">
        <guess-table :tableData="tableData.list" @view="view" @update="update"></guess-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import GuessTable from "./GuessTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getGuessList,newVue} from "../../network/guess";

  export default {
    name: "activityList",
    components: {GuessTable, MyTable},
    data(){
      return {
        title: "获奖者答案列表",
        isAdd: true,
        isSearch:true,
        searchParams:[
          {
            key:"guesserContent",
            value:"获奖者答案"
          },
          {
            key:"isAwards",
            value:"是否获奖"
          }
        ],
        tableData:{},
        searchItems:{},
        activityId:null
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/activity/list";
      this.common.HeaderLocationTwo.name = "营销活动管理"
      this.common.HeaderLocationThree.name = "活动答案列表"
      this.activityId = this.$route.params.id;
      getGuessList(this.activityId).then(res => {
        this.tableData = res.data;
      })
    },
    methods:{
      pageNumChange(pageNum){
        this.searchEasy(this.searchItems,pageNum);
      },
      searchEasy(searchItems,pageNum){
        let guesserContent = null;
        let isAwards = null;
        for (let i = 0;i<searchItems.length;i++){
          if (searchItems[i].value === "guesserContent"){
            guesserContent = searchItems[i].input
          }else if (searchItems[i].value === "isAwards"){
            isAwards = searchItems[i].input
          }
        }
        getGuessList(this.activityId,guesserContent,isAwards,pageNum).then(res => {
          this.tableData = res.data
        })
      },
      addMerchants(){
        this.$router.push("insert/")
      },
      keyup(){
        this.searchEasy(this.searchItems);
      },
      search(searchItems){
        this.searchItems = searchItems;
        this.searchEasy(searchItems)
      },
      view(id){
        for (let i = 0;i<this.tableData.list.length;i++){
          if (this.tableData.list[i].id==id){
            this.tableData.list[i].isAwards = '是'
          }
        }
      },
      update(id){
        for (let i = 0;i<this.tableData.list.length;i++){
          if (this.tableData.list[i].id==id){
            this.tableData.list[i].isAwards = '否'
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
